// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".floating-icon-wrapper[data-v-a0d9e86a]{width:100px;position:fixed;bottom:80px;right:80px;z-index:99}.floating-icon-wrapper img[data-v-a0d9e86a]{width:100%}@media(max-width:768px){.floating-icon-wrapper[data-v-a0d9e86a]{width:80px;bottom:50px;right:20px}}", ""]);
// Exports
module.exports = exports;
